import { withRedux } from '@hoc/withRedux';
import useBodyScrollLock from '@hooks/useBodyScrollLock';
import { pinboards } from '@redux/slices/pinboards';
import { DrawerMode } from '@redux/slices/pinboards/types';
import { useAppDispatch, useAppSelector } from '@redux/store';
import * as React from 'react';
import ModalBackdrop from '../ModalBackdrop/ModalBackdrop';
import CopyPinboardItems from './CopyPinboardItems/CopyPinboardItems';
import CreatePinboard from './CreatePinboard/CreatePinboard';
import CreatePinboardItem from './CreatePinboardItem/CreatePinboardItem';
import DeletePin from './DeletePin/DeletePin';
import DeletePinboard from './DeletePinboard/DeletePinboard';
import ManagePinboard from './ManagePinboard/ManagePinboard';
import MovePinboardItems from './MovePinboardItems/MovePinboardItems';
import S from './PinboardActionDrawer.styles';
import RenamePinboard from './RenamePinboard/RenamePinboard';
const PinboardActionDrawer = () => {
    const dispatch = useAppDispatch();
    const drawer = useAppSelector((state) => state.pinboards.drawer);
    const ref = useBodyScrollLock(drawer.isActive);
    if (!drawer.isActive || !drawer.params) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBackdrop, null),
        React.createElement(S.Container, null, renderActionDrawer(drawer.params))));
    function renderActionDrawer(params) {
        switch (params.mode) {
            case DrawerMode.COPY_PINBOARD_ITEMS:
                return React.createElement(CopyPinboardItems, { scrollRef: ref, id: params.data, onCancel: handleCancel });
            case DrawerMode.CREATE_PINBOARD:
                return React.createElement(CreatePinboard, { scrollRef: ref, onCancel: handleCancel });
            case DrawerMode.CREATE_PINBOARD_ITEM:
                return React.createElement(CreatePinboardItem, { scrollRef: ref, params: params, onCancel: handleCancel });
            case DrawerMode.DELETE_PINBOARD:
                return React.createElement(DeletePinboard, { scrollRef: ref, id: params.data, onCancel: handleCancel });
            case DrawerMode.MANAGE_PINBOARD:
                return React.createElement(ManagePinboard, { scrollRef: ref, id: params.data, onCancel: handleCancel });
            case DrawerMode.MOVE_PINBOARD_ITEMS:
                return React.createElement(MovePinboardItems, { scrollRef: ref, id: params.data, onCancel: handleCancel });
            case DrawerMode.RENAME_PINBOARD:
                return React.createElement(RenamePinboard, { scrollRef: ref, id: params.data, onCancel: handleCancel });
            case DrawerMode.DELETE_PIN:
                return React.createElement(DeletePin, { scrollRef: ref, data: params.data, onCancel: handleCancel });
            default:
                throw new Error(`Invalid mode used for drawer.`);
        }
    }
    function handleCancel(event) {
        event.preventDefault();
        dispatch(pinboards.actions.hideDrawer());
    }
};
export default withRedux(PinboardActionDrawer);
